async function addProduct(productId) {
    const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
                    id: productId,
                    quantity: 1,
        })
    });

    if(response.ok){
    const data = await response.json();
    return data;      
    }else{
      console.log("Something Went Wrong.")
    }
}

async function removeFromCart(lineItemId) {
    const response = await fetch(`/cart/change.js?id=${lineItemId}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            id: lineItemId,
            quantity: 0
        })
    });

    if(response.ok){
    const data = await response.json();
    return data;      
    }else{
      console.log("Something Went Wrong.")
    }
}


const setCartTotalPrice = ()=>{
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));
}

const toggle_cart_protection_product = ()=>{
const switch__cart_protection_product = document.querySelector(".switch__cart_protection_product .toggle__switch");
if(switch__cart_protection_product){
  document.querySelector(".switch__cart_protection_product").classList.add("disabled_snippet");
  const switch__cart_product_label = document.querySelector(".switch__cart_protection_product .toggle__switch label");
  const switch__cart_product_label_checked = document.querySelector(".switch__cart_protection_product .toggle__switch label.checked");
  const id = +document.querySelector(".switch__cart_protection_product ._id").value;
  const grayImgStyle = document.querySelector(".switch__cart_protection_product .horizontal-product");

  if(switch__cart_product_label_checked){
    removeFromCart(+id).then((data)=>{
      if(data){
        switch__cart_product_label_checked.classList.remove("checked");
        grayImgStyle.classList.add("switch__");
        document.querySelector(".switch__cart_protection_product").classList.remove("disabled_snippet");
          setCartTotalPrice();
      }
    })
  }else{
    addProduct(+id).then((data)=>{
          switch__cart_product_label.classList.add("checked");
          grayImgStyle.classList.remove("switch__");
          if(data){
            document.querySelector(".switch__cart_protection_product").classList.remove("disabled_snippet");
            setCartTotalPrice();
          }
    });
  }
}
}



const buy_buttons_block = document.querySelector(".product-info__block-item[data-block-id='buy_buttons']");


const observerCallback = (entries) => {
    const btn = document.querySelector("product-quick-add.product-quick-add");
    entries.forEach(entry => {
        if (!entry.isIntersecting) {
            btn.setAttribute('data-is-visible', true);
        } else {
            btn.setAttribute('data-is-visible', false);
        }
    });
};

const observer = new IntersectionObserver(observerCallback, {
    threshold: [0] // Trigger when any part of the button is not visible
});

if(buy_buttons_block){
observer.observe(buy_buttons_block); 
}










// document.addEventListener('DOMContentLoaded', function() {
// const getData = document.querySelector("div[data-order_protection_product_false]");

// let got_it = false;
// const my_interval = setInterval(()=>{
// if(getData && !got_it){
//     const id = getData.getAttribute("data-order_protection_product_false");
//     addProduct(+id).then((data)=>{
//           if(data){
//             setCartTotalPrice();
//           }
//     });
//   got_it = true;
//   clearInterval(my_interval);
// }  
// },1000)

// });